import { Text, Flex, Box } from '@cad-arc';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { FormCheckbox } from '../forms/integrated-form-controls/form-checkbox';
import { SearchFormFooter } from '../search-windows/search-form-footer';
import { eventSearchFormDefaultValues } from './configuration';
import { EventSearchFormType } from './types';
import { isFormModified } from './utils';

export function EventSearchFormFooter({ form }: { form: UseFormReturn<EventSearchFormType> }) {
    const formValues = useWatch({ control: form.control });
    const isValid = isFormModified(formValues, eventSearchFormDefaultValues);
    return (
        <SearchFormFooter isFormValid={isValid} onClearAllFields={() => form.reset()} isAgencyEvent>
            <Flex alignItems="center" flexWrap="nowrap" gap={8}>
                <Box>
                    <FormCheckbox
                        name="includeActiveEvents"
                        label="Include Active Events"
                        control={form.control}
                    />
                </Box>
                <Flex gap={2} alignItems="center">
                    <Box>
                    <FormCheckbox
                        name="fuzzyMatchingEnabled"
                        label="Enable Fuzzy Matching"
                        control={form.control}
                    />
                    </Box>
                    <Text
                        variant="caption"
                        color="tertiary"
                    >
                        (May slow search speed)
                    </Text>
                </Flex>
            </Flex>
        </SearchFormFooter>
    );
}
